import { DemandReportsActionTypes } from './demandReportsTypes';

export const demandReportGetDemandReport = (payload: any) => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_GET_REPORT,
	payload
});

export const demandReportGetDemandReports = (payload: any) => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_GET_REPORTS
});

export const demandReportGetDemandReportsSuccess = (payload: any) => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_GET_REPORTS_SUCCESS,
	payload
});

export const demandReportGetDemandReportsFailure = (payload: any) => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_GET_REPORTS_FAILURE,
	payload
});

export const demandReportGetAllDemandReportsSuccess = (payload: any) => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_GET_ALL_REPORTS_SUCCESS,
	payload
});

export const demandReportGetAllDemandReportsNoReports = () => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_GET_ALL_REPORTS_NO_REPORTS
});

export const demandReportResetDemandReportsFailure = () => ({
	type: DemandReportsActionTypes.DEMAND_REPORT_RESET_DEMAND_REPORT_FAILURE
});
